export const MAX_RETRIES = 5;
export const RETRY_STATUSES = [408, 429, 502, 503, 504];

const REPLAY_SAFE_METHODS = new Set(["GET", "HEAD", "OPTIONS"]);

export function isReplaySafe(method: string | undefined): boolean {
  return REPLAY_SAFE_METHODS.has((method ?? "GET").toUpperCase());
}

export function shouldRetry(
  method: string | undefined,
  attempt: number,
  error: Error | null,
  response: Response | null,
): boolean {
  if (attempt >= MAX_RETRIES || !isReplaySafe(method)) return false;
  if (response === null) return error?.name !== "AbortError";
  return RETRY_STATUSES.includes(response.status);
}
